import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { __, _x } from "../../utils";
import { Spin, Modal } from "antd";
const PluginUpdateLicenseTelemetryDataModal = observer((param)=>{
    let { license, linkWrapper, disabled, children } = param;
    const { busy, telemetryData, telemetryDataSharingOptIn } = license;
    const [isVisible, setVisible] = useState(false);
    useEffect(()=>{
        if (isVisible && !telemetryData) {
            license.fetchTelemetryData();
        }
    }, [
        isVisible,
        telemetryData,
        license
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Modal, {
                title: __("Telemetry data preview"),
                open: isVisible && !disabled,
                onCancel: ()=>setVisible(false),
                cancelText: __("Close"),
                okButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                children: [
                    telemetryDataSharingOptIn && /*#__PURE__*/ _jsx("p", {
                        style: {
                            marginTop: 0,
                            marginBottom: 10
                        },
                        children: _x("At the time of activating the license, you agreed that we may send telemetry data from your installation to our server. You can revoke this at any time by deactivating and reactivating the licence.", "legal-text")
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        style: {
                            marginTop: 0
                        },
                        children: __("The following data (raw) will be sent to our server:")
                    }),
                    /*#__PURE__*/ _jsx(Spin, {
                        spinning: busy,
                        children: /*#__PURE__*/ _jsx("textarea", {
                            readOnly: true,
                            style: {
                                width: "100%",
                                height: 300
                            },
                            value: telemetryData ? JSON.stringify(telemetryData, null, 4) : ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                onClick: (e)=>{
                    if (!disabled) {
                        setVisible(true);
                    }
                    e.preventDefault();
                },
                children: linkWrapper ? /*#__PURE__*/ _jsx("a", {
                    children: children
                }) : children
            })
        ]
    });
});
export { PluginUpdateLicenseTelemetryDataModal };
